// extracted by mini-css-extract-plugin
export default {"root":"CustomDragPreview_root__Gzc3B"};